import styled, { css } from 'styled-components';

import {
    Button,
    Image,
    Spacer,
    Text,
    mediaMixin,
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledGuaranteeIcon = styled(Image)`
    display: none;

    ${mediaMixin('lg', css`
        display: block;
        margin-right: ${spaceMixin('xs')};
        height: 32px;
        width: 32px;
    `)}
`;

export const StyledMiddleFlex = styled.div`
    display: flex;
    align-items: center;
    margin-right: ${spaceMixin('xs')};

    ${mediaMixin('lg', css`
        justify-content: space-between;
        flex-grow: 1;
    `)}
`;

export const StyledFlexContainer = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    align-self: center;

    ${mediaMixin('lg', css`
        flex-direction: row;
        align-items: center;
    `)}
`;

export const StyledTagSpacer = styled(Spacer)`
    margin-bottom: 6px;

    ${mediaMixin('lg', css`
        margin-bottom: 0px;
    `)}
`;

export const StickyListingFooterContainer = styled.div`
    /*
     * if placeholder is visible, then changes back to fixed
     * else sticky
     */
    ${props => (props.isVisible ? (
        css`
            position: static;
            box-shadow: 0;
        `
    ) : (
        css`
            position: fixed;
            box-shadow: 0 0 7px -2px rgba(0, 0, 0, 0), 0 0 3px 0 rgba(0, 0, 0, 0.26);
        `
    ))}

    border-top: 1px solid ${token('colors.gray300')};
    bottom: 0;
    left: 0;
    width: 100%;
    background: ${token('colors.white')};
    z-index: 270;
    min-height: 114px;
    display: flex;

    padding: ${props => (props.isVisible ? '16px 0' : '16px 10px')};

    /* 481 */
    ${mediaMixin('md', css`
        min-height: 0;
        height: 76px;
    `)}

    /* 769 */
    ${mediaMixin('lg', css`
        padding: ${props => (props.isVisible ? '16px 0' : '16px 24px')};
    `)}
`;

export const StyledContainer = styled.div`
    display: flex;
    justify-content: space-between;
    max-width: 1280px;
    margin: 0 auto;
    width: 98vw;
`;

export const StyledText = styled(Text)`
    && {
        font-size: 12px;
        font-weight: 400;

        ${mediaMixin('lg', css`
            font-size: 14px;
            font-weight: 600;
        `)}

        /* 1024 */
        ${mediaMixin('xl', css`
            font-size: 16px;
        `)}
    }
`;

export const StyledButton = styled(Button)`
    align-self: center;

    /*
        when sibling element expands it's height
        the button height increases to match
        we need to explicitly set the height of the button

        the height value take from constellation ::after
     */
    height: 44px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;
